import { CriminalAuthDraft } from "../pages/candidate-pages/candidate-forms/CriminalRecordsAuthForm";
import { ReferenceIdentificationDraft } from "../pages/candidate-pages/candidate-forms/ReferenceIdentificationForm";
import { fetchWithAuth } from "./fetchWithAuth";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_API_URL
      : DEV_API_URL;

export const saveDraftCriminalAuth = async (
  orderID: number,
  orderFormID: number,
  draftData: object,
) => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/Draft/SaveDraftCriminalAuth`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        orderID,
        orderFormID,
        draftData,
      }),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to save draft.");
  }

  return response.json();
};

export const loadCriminalAuthDraft = async (
  orderID: number,
  orderFormID: number,
): Promise<CriminalAuthDraft | null> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/Draft/LoadCriminalAuthDraft`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        orderID,
        orderFormID,
      }),
    },
  );

  if (response.status === 204) {
    return null;
  }

  if (!response.ok) {
    throw new Error("Failed to load draft.");
  }

  return response.json();
};

export const saveDraftReferenceIdentification = async (
  orderID: number,
  orderFormID: number,
  draftData: object,
) => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/Draft/saveDraftReferenceIdentification`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        orderID,
        orderFormID,
        draftData,
      }),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to save draft.");
  }

  return response.json();
};

export const loadReferenceIdentificationDraft = async (
  orderID: number,
  orderFormID: number,
): Promise<ReferenceIdentificationDraft | null> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/Draft/LoadReferenceIdentificationDraft`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        orderID,
        orderFormID,
      }),
    },
  );

  if (response.status === 204) {
    return null;
  }

  if (!response.ok) {
    throw new Error("Failed to load draft.");
  }

  return response.json();
};

export const deleteDraft = async (
  orderID: number,
  orderFormID: number,
  formType: string,
): Promise<void> => {
  if (!apiBaseUrl) throw new Error("API URL is not defined");

  const token = localStorage.getItem("token");
  if (!token) throw new Error("User is not authenticated");

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/Draft/DeleteDraft?orderID=${orderID}&orderFormID=${orderFormID}&formType=${formType}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok && response.status !== 404) {
    throw new Error("Failed to delete draft.");
  }
};
